import React from 'react'
import '../../styles/contact.css'
import ContactForm from './ContactForm'
import BookingContacts from './BookingContacts'

const Contact = () => {
  return (
    <>
      <BookingContacts />
      <ContactForm />
    </>
  )
}

export default Contact
